module.exports = __webpack_public_path__ + "assets/img/left-title-open-17cf28ac.png";